import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-card-skeleton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card-skeleton.html',
  styleUrl: './card-skeleton.scss'
})
export class CardSkeleton {
  @Input() mediaType: string = 'movie';
}
